import React from 'react';

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-auto">
      <img
        src="/logoH2.png"
        alt="Loading..."
        className="h-36 animate-pulse"
      />
    </div>
  );
};

export default Loader;
